// analyticsDefaults.js

export const analyticsDefaults = {
    filters: {
        agentName: { title: 'Agent Name', defaultVisible: true },
        callType: { title: 'Call Type', defaultVisible: true },
        duration: { title: 'Duration', defaultVisible: true },
    },
    metrics: {
        profScore: { title: 'Professionalism Score' },
        protScore: { title: 'Protocol Score' },
        qualScore: { title: 'Quality Score' },
    },
    callList: {
        columns: [
            { id: 'agentName', label: 'Agent', field: 'agentName' },
            { id: 'duration', label: 'Call Duration', field: 'duration' },
            { id: 'callType', label: 'Call Type', field: 'callType' },
        ],
        flags: [
            {
                id: 'needsAttention',
                label: 'Attention Needed',
                condition: 'record.needsAttention === true',
                style: { backgroundColor: '#fef3c7', color: '#92400e' }
            },
            {
                id: 'wasScheduled',
                label: 'Scheduled',
                condition: 'record.wasScheduled === true',
                style: { backgroundColor: '#d1fae5', color: '#065f46' }
            },
            {
                id: 'wasTransferred',
                label: 'Transferred',
                condition: 'record.wasTransferred === true',
                style: { backgroundColor: '#dbeafe', color: '#1e40af' }
            }
        ],
        tags: [
            { id: 'language', label: 'Language', field: 'language' },
            { id: 'prefOffice', label: 'Office', field: 'prefOffice' },
            { id: 'requestedDoctor', label: 'Doctor', field: 'requestedDoctor' }
        ],
        accentColor: {
            type: 'metric', // 'metric', 'conditions', or 'expression'
            metric: {
                field: 'qualScore',
                expression: '',
                maxValue: 100,
                useAutoMax: true
            },
            conditions: [
                { condition: 'record.qualScore > 80', color: '#22c55e' },
                { condition: 'record.qualScore > 65', color: '#f97316' },
                { condition: 'record.qualScore <= 65', color: '#ef4444' }
            ],
            defaultColor: '#e5e7eb',
            expression: ''
        },
        sortCriteria: [
            { field: 'rawDate', direction: 'desc', label: 'Date/Time' }
        ]
    },
    scorecards: {
        groupByField: "agentName",
        layout: {
            columns: 3,
            cardHeight: "auto"
        },
        metrics: {
            wheels: [
                {
                    id: "qualityScore",
                    label: "Quality Score",
                    calculation: {
                        type: "average",
                        fields: ["profScore", "protScore"]
                    }
                }
            ],
            bars: [
                {
                    id: "profScore",
                    label: "Professional Score",
                    calculation: {
                        type: "average",
                        fields: ["profScore"]
                    }
                },
                {
                    id: "protScore",
                    label: "Protocol Score",
                    calculation: {
                        type: "average",
                        fields: ["protScore"]
                    }
                }
            ],
            tags: [
                {
                    id: "totalCalls",
                    label: "Calls",
                    calculation: {
                        type: "count"
                    },
                    style: {
                        backgroundColor: "#f3f4f6",
                        color: "#6b7280"
                    }
                },
                {
                    id: "attentionCalls",
                    label: "Attention",
                    calculation: {
                        type: "count",
                        condition: "record.needsAttention === true"
                    },
                    style: {
                        backgroundColor: "#fef3c7",
                        color: "#92400e"
                    }
                },
                {
                    id: "transferredCalls",
                    label: "Transferred",
                    calculation: {
                        type: "count",
                        condition: "record.wasTransferred === true"
                    },
                    style: {
                        backgroundColor: "#dbeafe",
                        color: "#1e40af"
                    }
                },
                {
                    id: "scheduledCalls",
                    label: "Scheduled",
                    calculation: {
                        type: "count",
                        condition: "record.wasScheduled === true"
                    },
                    style: {
                        backgroundColor: "#d1fae5",
                        color: "#065f46"
                    }
                }
            ]
        },
        sorting: {
            field: "qualityScore",
            direction: "desc"
        },
        comparison: {
            enabled: true,
            fields: ["profScore", "protScore", "qualityScore"],
            labels: {
                profScore: "Prof",
                protScore: "Prot",
                qualityScore: "Qual"
            },
            format: "percentage"
        },
        customFields: [],
    }
};
